import React, { useState, useEffect } from 'react';
import { FaTimes, FaChevronRight, FaSearch, FaCheckSquare, FaSquare } from 'react-icons/fa';

function CountriesDropdown({ onClose, selectedCountry, onCountryChange, countryData }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContinent, setSelectedContinent] = useState(''); // Keep track of selected continent for potential future use
  const [allContinents, setAllContinents] = useState([]);

  // Effect to extract unique continents from countryData
  useEffect(() => {
    if (countryData) {
      const continents = [...new Set(countryData.map(item => item.continent))].filter(Boolean).sort();
      setAllContinents(continents);
    }
  }, [countryData]);

  // Hardcoded list of 7 continents
  const CONTINENTS = [
    "Africa",
    "Asia",
    "Europe",
    "North America",
    "Oceania",
    "South America",
    "Antarctica"
  ];

  // Use hardcoded continents for display
  const displayItems = CONTINENTS;

  // Filter the display items based on the search term
  const filteredDisplayItems = displayItems.filter(item =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Filter countries for the selected continent
  const filteredCountries = countryData && CONTINENTS.includes(selectedCountry)
    ? countryData.filter(c => c.continent === selectedCountry)
    : [];

  // This component is currently set up to select a single country.
  // Selecting a continent as per the image might imply navigating to a country list for that continent, 
  // or selecting all countries in that continent. The current onCountryChange doesn't support this directly.
  // For now, clicking a continent will just log the selection. The checkbox next to continents will be non-functional.
  const handleItemClick = (item) => {
    onCountryChange(item); // Always pass the continent name as the selected value
  };

  // Render checkboxes based on the selected item. 
  // Now, selectedCountry can be '' (all countries) or a continent name.
  const renderCheckbox = (item) => {
    return selectedCountry === item ? <FaCheckSquare color="blue" /> : <FaSquare />;
  };

  return (
    <div className="countries-dropdown">
      <div className="dropdown-header">
        <h3>COUNTRIES/REGIONS</h3>
        <FaTimes className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}/>
      </div>
      <div className="dropdown-content">
         <div className="search-input-container">
            <FaSearch />
            <input
              type="text"
              placeholder="Search Countries/Regions"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
         </div>

         {/* Continent dropdown removed, only show the list */}
         <div className="options-list">
           {displayItems.map(item => (
             <div
               key={item}
               className={`option-item ${selectedCountry === item ? 'selected' : ''}`}
               onClick={() => handleItemClick(item)}
             >
               <div className="checkbox-container">
                 {renderCheckbox(item)}
               </div>
               <span>{item}</span>
               <FaChevronRight className="chevron-icon"/>
             </div>
           ))}
         </div>

         {/* Show country dropdown if a continent is selected */}
         {filteredCountries.length > 0 && (
           <div className="country-select-container" style={{ margin: '16px 0' }}>
             <label htmlFor="country-select" style={{ fontWeight: 'bold', marginRight: '8px' }}>Select Country:</label>
             <select
               id="country-select"
               className="pretty-select"
               onChange={e => onCountryChange(e.target.value)}
               defaultValue=""
             >
               <option value="" disabled>Select a country</option>
               {filteredCountries.map(country => (
                 <option key={country.code || country.name} value={country.name}>{country.name}</option>
               ))}
             </select>
           </div>
         )}
      </div>
    </div>
  );
}

export default CountriesDropdown; 